import { smoothScroll } from '@gn-audio/ui/tools/smooth-srcoll';
import { domUtils } from './utilities/dom-utils';
export var ScrollToOnInitDirective = [
    '$location',
    function ($location) {
        return {
            link: function () {
                var hash = $location.url()
                    .replace(/\//, '');
                var targetElement = domUtils.getElement(hash);
                if (!targetElement) {
                    return;
                }
                smoothScroll(targetElement);
            },
            restrict: 'A',
        };
    },
];
